module.exports = __webpack_public_path__ + "static/media/edit.cdd8c829.svg";